import type {
  EquityShareChartStateResponse,
  SaveEquityShareDecisionRequest,
  SaveEquityShareDecisionResponse,
} from "@repo/shared/types";
import { get, post } from "../_client";

const BASE = "/internal/flow-instances";

export function getEquityShareChartState(instanceId: string, goalId: string) {
  return get<EquityShareChartStateResponse>(
    `${BASE}/${instanceId}/goals/${goalId}/equity-share-chart`,
  );
}

export function saveEquityShareChartDecision(
  instanceId: string,
  goalId: string,
  request: SaveEquityShareDecisionRequest,
) {
  return post<SaveEquityShareDecisionResponse>(
    `${BASE}/${instanceId}/goals/${goalId}/equity-share-chart/decision`,
    request satisfies SaveEquityShareDecisionRequest,
  );
}
